// ManiDine Restaurant Web — src/pages/reports/ReportsLayout.jsx — Updated: 2026-03-31 14:12 (America/Edmonton)
import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import ManagerShell from "../../components/ManagerShell";
import "./Reports.css";

const tabs = [
  { to: "/reports/sales", label: "Restaurant Sales" },
  { to: "/reports/orders", label: "Orders & Operations" },
  { to: "/reports/menu", label: "Menu Insights" },
  { to: "/reports/customers", label: "Customer Insights" },
  { to: "/reports/financial", label: "Payout Ledger" },
  { to: "/reports/store", label: "Store Performance" },
  { to: "/reports/forecast", label: "Forecasting" },
];

const ReportsLayout = () => {
  return (
    <ManagerShell
      title="Reports"
      subtitle="Analyze restaurant-only sales, tax, operations, customer trends, and payout deductions in clearly separated report views."
    >
      <div className="reports-root">
        <header className="reports-header">
          <div>
            <h1 className="reports-title">Reports</h1>
            <p className="reports-subtitle">
              Restaurant sales reports show food subtotal plus tax only. Delivery fees,
              customer tips, and payout deductions are kept separate so totals stay clear.
            </p>
          </div>
        </header>

        <nav className="reports-tabs">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                "reports-tab" + (isActive ? " reports-tab--active" : "")
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>

        <main className="reports-content">
          <Outlet />
        </main>
      </div>
    </ManagerShell>
  );
};

export default ReportsLayout;
